import React from "react";
import Text from "../text";
import { DividerContainer, Separator } from "./styled-components";

const Divider = () => {
  return (
    <DividerContainer>
      <Separator />
      <Text weight={400} size="14px" color="grey400">
        OU
      </Text>
      <Separator />
    </DividerContainer>
  );
};

export default Divider;
